import { useCallback } from 'react';

export const useAssetDetailsPageActions = ({
  dataService,
  navigation,
  assetId,
  folderAssetType,
  reloadLandingPageRef,
  renameAsset,
}) => {
  const {
    deleteAsset,
  } = dataService || {};

  const handleDeleteAsset = useCallback(() => deleteAsset({ assetId, folderAssetType }).then(() => {
    // eslint-disable-next-line no-param-reassign
    reloadLandingPageRef.current = true;
  }), [assetId, deleteAsset, folderAssetType, reloadLandingPageRef]);

  const handleRenameAsset = useCallback(newName => renameAsset({ assetId, name: newName, folderAssetType }).then(() => {
    // eslint-disable-next-line no-param-reassign
    reloadLandingPageRef.current = true;
  }), [assetId, folderAssetType, reloadLandingPageRef, renameAsset]);

  const gotoAdsPageWithAssetIdFilter = useCallback(() => navigation.gotoAdsPageWithAssetIdFilter({
    folderAssetType,
    assetId,
  }), [assetId, folderAssetType, navigation]);

  const copyUrl = useCallback((url) => {
    navigator.clipboard.writeText(url);
  }, []);

  return {
    handleDeleteAsset,
    handleRenameAsset,
    gotoAdsPageWithAssetIdFilter,
    copyUrl,
  };
};
